const colors = {
  primary: {
    100: '#FEFFF6',
    200: '#F6FCC6',
    300: '#EFFA95',
    400: '#E7F765',
    500: '#DFF434',
    600: '#D2EA0C',
    700: '#A6B90A',
    800: '#7B8907',
  },
  secondary: {
    100: '#E0F8E6',
    200: '#B7EEC5',
    300: '#8EE4A3',
    400: '#65DA82',
    500: '#3CD061',
    600: '#2aaf4b',
    700: '#208639',
  },
  neutral: {
    0: '#FFFFFF',
    25: '#F9F9F9',
    50: '#F3F3F5',
    100: '#E2E2E5',
    200: '#C6c6ce',
    300: '#ABABB6',
    400: '#90909E',
    500: '#5D5D6B',
    600: '#454550',
    700: '#2E2E34',
    800: '#1E1E22',
    900: '#0a0a0b',
  },
  error: {
    100: '#FFF3F1',
    200: '#FED1C6',
    300: '#FEA893',
    400: '#FD7F61',
    500: '#FA5739',
    600: '#F3351C',
    700: '#C22702',
  },
  warning: {
    100: '#Fff2df',
    200: '#Fff2df',
    300: '#Feddad',
    400: '#FEC87A',
    500: '#Fda92e',
    600: '#dd8302',
    700: '#915601',
  },
  success: {
    100: '#dcf0e4',
    200: '#a5daba',
    300: '#81cb9f',
    400: '#4BB575',
    500: '#3c915e',
    600: '#2d6d46',
    700: '#1E492F',
  },
  information: {
    100: '#DEEEF4',
    200: '#A2C8D8',
    300: '#6CA8C2',
    400: '#42839F',
    500: '#33657b',
    600: '#244857',
    700: '#152A33',
  },
};

export default colors;
